export function canPrintDynamicSoa(cif, systemPropertyService) {
  const csv = systemPropertyService.getProperty('RT_BS_ACCOUNTS_CUSTOMERS_LIST') || '';
  return csv.split(/\s*,\s*/).filter(Boolean).includes(String(cif).trim());
}
